import { withStudentsList } from '../../students/components/students.container';
import { UsersPickerView } from './users-picker.component';

export const UsersPicker = withStudentsList(UsersPickerView);
